import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import AddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import PropTypes from 'prop-types';
import React from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { connect } from 'react-redux';
import { getEntrepriseSalaries } from "../../../../actions/entreprise/actions_entreprise_1";
import CustomDatePicker from '../../../shared/utils/CustomDatePicker';
import moment from '../../../shared/utils/moment_fr';
import AuthService from "./../../../../services/AuthService";

class OneSalarieForm extends React.Component {

    static defaultProps = {
        showEditButtons: false
    };

    static propTypes = {
        showEditButtons: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = this.props.initialState || {
            classification: "",
            cnn: "",
            date_entree_entreprise: new Date().toISOString().substring(0, 10),
            date_naissance: new Date().toISOString().substring(0, 10),
            email: "",
            id: "",
            id_niv_formation: "1",
            id_societe: "",
            intitule_formation: "",
            niv_formation: "",
            nom: "",
            num_salarie: "",
            prenom: "",
            budget_cpf: 0
        };
        this.Auth = new AuthService();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    static getDerivedStateFromProps(nextProps, prevState) {
        let toReturn = null;
        if (nextProps.initialState && nextProps.initialState.id !== prevState.id) {
            toReturn = nextProps.initialState;
        } else {
            toReturn = prevState;
        }
        for (let key in toReturn) {
            if (toReturn.hasOwnProperty(key) && key.startsWith('date_')) {
                toReturn[key] = new Date(toReturn[key]);
            }
        }
        return toReturn;
    }

    handleChange(event, value) {
        if (typeof value === 'object')
            value = moment(value).format("YYYY-MM-DD");
        let obj = {};
        obj[event.target.name] = value;
        this.setState(obj);
    }

    handleSubmit() {
        this.Auth.fetch("/societe/salaries", {
            method: this.props.submitMethod,
            data: this.state
        }).then(x => {
            this.props.dispatch(getEntrepriseSalaries());
            alert(this.props.submitSuccessMsg);
        })
            .catch(err => {
                alert(err.response.data.payload)
            });
    }

    render() {
        let niv_form = [];
        this.props.niveaux_de_formations.map(x => niv_form.push(<MenuItem key={x.id} value={x.id}
            primaryText={x.legende} />));

        return (
            <div className='row justify-content-md-center'>
                <div className='col col-sm-10'>
                    <ValidatorForm
                        ref="form"
                        onSubmit={this.handleSubmit}
                    >
                        {this.props.showEditButtons &&
                            <div>
                                <RaisedButton
                                    style={{ marginRight: 5 }}
                                    primary={true}
                                    label="Archiver"
                                />
                                <RaisedButton
                                    secondary={true}
                                    label="Supprimer"
                                    onClick={() => {
                                        if (window.confirm('Êtes vous sûr de vouloir supprimer le salarié ' + this.state.nom + ' ?\nCeci supprimera toutes les données liées au salarié.')) {
                                            console.log('deleting: ', this.state.nom);
                                            this.Auth.fetch('/societe/salaries/' + this.state.id, { method: 'delete' })
                                                .then(res => {
                                                    this.props.dispatch(getEntrepriseSalaries());
                                                    alert('Utilisateur : ' + this.state.nom + ' supprimé.');
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                    alert('une erreur a survenu.');
                                                });
                                        }
                                    }
                                    }
                                />
                            </div>
                        }
                        <TextValidator
                            value={this.state.nom}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name='nom'
                            type="text"
                            validators={['required', 'trim']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            floatingLabelText="Nom du salarié"
                        /><br />
                        <TextValidator
                            value={this.state.prenom}
                            fullWidth={true}
                            onChange={this.handleChange}
                            name='prenom'
                            validators={['required', 'trim']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            type="text"
                            floatingLabelText="Prénom du salarié"
                        /><br />
                        <CustomDatePicker
                            floatingLabelText="Date de naissance"
                            stringValue={this.state.date_naissance}
                            onChange={(x, y) => this.handleChange({ target: { name: 'date_naissance' } }, y)}
                        />
                        <TextValidator
                            value={this.state.email}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name='email'
                            type="email"
                            validators={['required', 'isEmail']}
                            errorMessages={['Ce champs est obligatoire', 'Format incorrect.']}
                            floatingLabelText="Email du salarié"
                        /><br />
                        <CustomDatePicker
                            floatingLabelText="Date d'entrée en entreprise"
                            stringValue={this.state.date_entree_entreprise}
                            onChange={(x, y) => this.handleChange({ target: { name: 'date_entree_entreprise' } }, y)}
                        />
                        <SelectField
                            floatingLabelText="Niveau de formation"
                            name="id_niv_formation"
                            value={this.state.id_niv_formation}
                            onChange={(x, y, z) => this.handleChange({ target: { name: 'id_niv_formation' } }, z)}
                            fullWidth={true}
                        >
                            {niv_form}
                        </SelectField>
                        <TextValidator
                            value={this.state.intitule_formation}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name="intitule_formation"
                            type="text"
                            validators={['required', 'trim']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            floatingLabelText="Intitulé de la formation"
                        /><br />
                        <TextValidator
                            value={this.state.budget_cpf}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name="budget_cpf"
                            type="number"
                            validators={['required']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            floatingLabelText="Budget CPF mobilisable (euros)"
                        /><br />
                        <TextValidator
                            value={this.state.classification}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name="classification"
                            validators={['required', 'trim']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            type="text"
                            floatingLabelText="Classification"
                        /><br />
                        <TextValidator
                            value={this.state.cnn}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name="cnn"
                            type="text"
                            validators={['required', 'trim']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            floatingLabelText="Convention Collective Nationale"
                        /><br />
                        <TextValidator
                            value={this.state.num_salarie}
                            onChange={this.handleChange}
                            fullWidth={true}
                            name="num_salarie"
                            type="text"
                            validators={['required', 'trim']}
                            errorMessages={['Ce champs est obligatoire', 'Ce champs est obligatoire']}
                            floatingLabelText="Numéro du salarié"
                        /><br /><br />
                        <RaisedButton
                            type="submit"
                            label={this.props.submitBtnTxt}
                            labelPosition="before"
                            icon={this.props.submitMethod.toUpperCase() === 'POST' ? <AddIcon /> : <EditIcon />}
                        />
                    </ValidatorForm>
                </div>
            </div>
        );
    }
}



function mapStateToProps(store) {
    return { niveaux_de_formations: store.params.niveaux_formation }
}

export default connect(mapStateToProps)(OneSalarieForm);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/OneSalarieForm.js